<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import Store from '@/store'
import BaseButton from '@/components/base-button'
import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'

export default {

  name: 'ErrorPage',

  components: {
    BaseButton
  },

  beforeRouteEnter (to, from, next) {
    Store.commit('endLoading')
    next()
  },

  beforeRouteUpdate (to, from, next) {
    Store.commit('endLoading')
    next()
  },

  created(){
    this.setTitle();
  },

  computed: {
    code () {
      return this.$route.query.code
        ? this.$route.query.code
        : 404
    },

    message () {
      return parseInt(this.code) === 404
        ? this.$t('page-not-found')
        : this.$t('server-error')
    },

    errors () {
      return typeof this.$route.query.errors === 'object'
        ? this.$route.query.errors
        : [this.$route.query.errors]
    }
  },

  methods: {

    setTitle(){
      let title = document.getElementsByTagName('title')[0];
      return title.text = '404 not found';
    },

    enter (el, done) {
      Tween.from(el, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete: done
      })
    },

    leave (el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done()
      } else {
        Tween.to(el, 0.5, {
          autoAlpha: 0,
          ease: Power1.easeOut,
          onComplete: done
        })
      }
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.error-page
  .error-page__content

      h1.error-page__title {{ code }}
      p.error-page__description {{ message }}
      pre.error-page__errors
        p(v-for="error in errors") {{ error }}

      base-button.error-page__button(:label="$t('go-to-homepage')" url="/")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.error-page
  display flex
  justify-content center
  align-items center
  height 100%

  &__content
    display flex
    flex-direction column
    justify-content center
    align-items center
    max-width 740px
    width 100%

    +mobile()
      max-width calc(100% - 40px)

  &__title
    font-size 86px
    font-weight 500
    line-height 78px
    padding-bottom 28px

    +hd()
      font-size 100px
      line-height 87px

    +tablet()
      font-size 76px
      font-weight normal

    +mobile()
      font-size 34px
      line-height 37px
      font-weight 500

  &__description
    font-size 17px
    line-height 26px
    padding-bottom 28px

    +devices()
      font-size 14px
      line-height 22px

  &__errors
    white-space pre-wrap
    font-size 14px
    line-height 22px
    padding-bottom 28px

  &__button
    align-self center !important


</style>



// WEBPACK FOOTER //
// index.vue?fed67f86